<template>
  <div class="upload_works container">
    <div class="header">
      <el-page-header @back="$router.go(-1)" content="请填写作品信息">
      </el-page-header>
    </div>
    <div class="main">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <!-- <el-form-item label="章节:" prop="classChapterId">
          <el-select v-model="form.classChapterId" placeholder="请选择章节">
            <el-option-group
              v-for="group in chapterList"
              :key="group.classChapterId"
              :label="group.title"
            >
              <el-option
                v-for="item in group.children"
                :key="item.classChapterId"
                :label="item.title"
                :value="item.classChapterId"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属实战:" prop="taskId">
          <el-select
            v-model="form.taskId"
            placeholder="请所属实战"
            :disabled="!!$route.query.worksId || !!$route.query.taskId"
          >
            <el-option
              v-for="item in pList"
              :key="item.taskId"
              :label="item.title"
              :value="item.taskId"
              :disabled="!!item.worksId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述:" prop="info">
          <el-input
            v-model="form.info"
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件:" class="file-tiem">
          <el-tooltip
            class="tips"
            placement="top"
            content="支持mp4、png、jpg、jpeg、gif等格式文件展示，其他格式文件只能下载"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
          <uploadFile
            @success="uploadSuccess"
            :fileType="fileType"
            style="display: inline-block"
          >
            <div class="uploader">
              <i class="el-icon-plus"></i>
            </div>
          </uploadFile>
          <div class="file_box" v-for="(t, idx) in fileList" :key="t.fileId">
            <i class="el-icon-error" @click.prevent="handleDel(idx)"></i>
            <video
              style="width: 100%; height: 100%"
              v-if="t.type == 'mp4'"
              :src="t.url"
              controls="controls"
            ></video>
            <el-image
              style="width: 100%; height: 100%"
              v-else-if="
                t.type == 'png' ||
                t.type == 'jpg' ||
                t.type == 'jpeg' ||
                t.type == 'gif'
              "
              :src="t.url"
              :preview-src-list="getImgList(t)"
            >
            </el-image>
            <div class="other-type" v-else>
              <i class="el-icon-document"></i>
              <p>{{ t.fileName }}</p>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="隐私设置:" prop="setting">
          <el-select v-model="form.setting" placeholder="请选择开放对象">
            <el-option
              v-for="item in settingList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="margin-top: 60px">
          <el-button class="btn" type="primary" @click="submitForm('form')"
            >发表</el-button
          >
          <el-button class="btn" @click="$router.go(-1)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { releaseWorks, editWorks, worksInfo } from "@/api/works";
import { practiceList } from "@/api/practice";
import uploadFile from "@/components/uploadFile";
export default {
  components: {
    uploadFile,
  },
  data() {
    return {
      form: {
        taskId: null,
        classChapterId: "",
        info: "",
        fileList: [],
        // setting: 0,
      },
      rules: {
        // classChapterId: {
        //   required: true,
        //   message: "请选择章节",
        //   trigger: "blur",
        // },
        // info: {
        //   required: true,
        //   message: "请填写描述",
        //   trigger: "blur",
        // },
      },
      fileList: [],
      settingList: [
        { value: 0, label: "公开" },
        { value: 1, label: "仅老师可见" },
        { value: 2, label: "仅团队可见" },
      ],
      fileType: [],
      pList: [],
    };
  },
  created() {
    if (!!this.$route.query.taskId)
      this.form.taskId = Number(this.$route.query.taskId);

    this.getList();
    let worksId = this.$route.query.worksId;
    if (worksId) this.getInfo(worksId);
  },
  computed: {
    chapterList() {
      return this.$store.state.chapterList;
    },
  },
  methods: {
    back() {
      this.$route.query.taskId
        ? this.$router.push({
            path: "/courseDetail/works",
            query: {
              id: this.$route.query.id,
              classChapterId: this.$route.query.classChapterId,
              chapterTitle: this.$route.query.chapterTitle,
            },
          })
        : this.$router.go(-1);
    },
    //   实战列表
    getList() {
      practiceList({
        classId: this.$route.query.id,
        classChapterId: this.$route.query.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.pList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 作品详情
    getInfo(worksId) {
      this.$loading.show();
      worksInfo(worksId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.form = res.data;
          this.fileList = [...res.data.fileList];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 上传成功
    uploadSuccess(file) {
      file.type = file.type.toLowerCase();
      let existed = this.fileList.some((item) => {
        return item.fileId == file.fileId;
      });
      if (existed) this.$message.warning("请勿重复上传");
      else {
        this.fileList.push(file);
        this.form.fileList.push(file);
      }
    },
    getImgList(t) {
      let images = [];
      images.push(t.url);
      return images;
    },
    handleDel(idx) {
      this.fileList.splice(idx, 1);
      this.form.fileList.splice(idx, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.info == "" && this.form.fileList.length == 0) {
            this.$message.warning("描述或者文件必须有其一");
            return;
          }
          this.form.classChapterId = this.$route.query.classChapterId;
          let worksId = this.$route.query.worksId;
          this.$loading.show();
          (worksId ? editWorks : releaseWorks)(this.form).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("发表成功");
              this.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    //   this.back();
    // },
  },
};
</script>

<style lang="less" scoped>
.upload_works {
  margin-top: 20px;
  height: 100%;
  .header {
    padding: 30px;
    background: #fff;
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 14px;
      }
    }
  }

  ::v-deep .main {
    margin: 20px 20px 0;
    padding: 60px 285px;
    height: calc(100% - 84px - 40px - 20px);
    text-align: left;
    background: #fff;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .file-tiem {
      position: relative;
      .tips {
        position: absolute;
        left: -35px;
        top: 40px;
      }
    }
    .el-textarea__inner {
      font-family: inherit;
    }
    .el-select {
      width: 100%;
    }

    .uploader {
      margin-right: 15px;
      width: 104px;
      height: 104px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409eff;
      }

      .el-icon-plus {
        font-size: 28px;
        color: #8c939d;
        width: 104px;
        height: 104px;
        line-height: 104px;
        text-align: center;
      }
    }

    .file_box {
      position: relative;
      display: inline-block;
      margin-right: 15px;
      width: 104px;
      height: 104px;
      border-radius: 6px;
      vertical-align: top;
      .other-type {
        padding: 15px 5px 0;
        width: 100%;
        height: 100%;
        text-align: center;
        border: solid 1px #ddd;
        border-radius: 6px;
        word-break: break-all;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 4px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
          border-radius: 10px;
          background-color: #f5f5f5;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
          background-color: #c8c8c8;
        }
        .el-icon-document {
          font-size: 24px;
        }
        p {
          line-height: 1;
          font-size: 12px;
        }
      }
      .el-icon-error {
        position: absolute;
        right: -10px;
        top: -10px;
        font-size: 20px;
        background: #fff;
        border-radius: 50%;
        color: #f56c6c;
        cursor: pointer;
        z-index: 999;
      }
    }
    .btn {
      margin-right: 60px;
      width: 97px;
      height: 40px;
    }
  }
}
</style>